<template>
    <section>
        <!-- <div class="w-100 mt-3 mb-4 align-items-center d-flex justify-content-center">
            <button class="style-buttons-advance-mode-btn-xs" @click="$emit('show-switch-mode')">
                Try Advanced Mode!
            </button>
        </div> -->

        <div :class="[containerClass]" @click="$emit('roomType-modal')">
            <div>
                <img
                    :src="
                        selectedRoomTypesLength === 0
                            ? require('@/assets/services/vs/room-type-icon.svg')
                            : require('../assets/room-type-icon.svg')
                    "
                    alt=""
                />
                <span v-if="selectedRoomTypes.length === 0" class="fsz-12 ms-2"
                    >Choose Your <span class="fw-bold">Roomtype</span> (Max. 3 Type)</span
                >
                <span v-else class="fsz-12 accent-color ms-2 fw-bold">
                    You choose {{ selectedRoomTypes[0].name }}
                    {{ selectedRoomTypes[1] ? `,${selectedRoomTypes[1].name}` : '' }}
                    {{
                        selectedRoomTypes[2]
                            ? `,${selectedRoomTypes[2].name.substring(0, 6)}...`
                            : ''
                    }}
                </span>
            </div>
            <img src="../assets/arrow-right.svg" alt="" />
        </div>
        <small v-if="emptyRoomTypeAlertFlag" class="text-danger">
            Please selected some Roomtypes
        </small>

        <div class="mt-3" :class="[containerStyleClass]" @click="openStylesModal">
            <div>
                <img
                    :src="
                        selectedStyleLength === 0
                            ? require('@/assets/services/vs/style-catalogue-icon.svg')
                            : require('../assets/style-category-icon.svg')
                    "
                    alt=""
                />
                <span v-if="selectedStyles.length === 0" class="fsz-12 ms-2">
                    Choose your favourite <span class="fw-bold">Style</span></span
                >
                <span v-else class="fsz-12 accent-color ms-2 fw-bold">
                    You choose {{ selectedStyles[0].name }}
                    {{ selectedStyles[1] ? `,${selectedStyles[1].name}` : '' }}
                    {{ selectedStyles[2] ? `,${selectedStyles[2].name.substring(0, 6)}...` : '' }}
                </span>
            </div>
            <img src="../assets/arrow-right.svg" alt="" />
        </div>
    </section>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    computed: {
        ...mapGetters(['selectedRoomTypes', 'selectedStyles']),
        selectedRoomTypesLength() {
            return this.selectedRoomTypes.length;
        },
        selectedStyleLength() {
            return this.selectedStyles.length;
        },
        containerClass() {
            return this.selectedRoomTypesLength === 0
                ? 'style-buttons-inactive-container-xs'
                : 'style-buttons-active-container-xs';
        },
        containerStyleClass() {
            return this.selectedStyles.length === 0
                ? 'style-buttons-inactive-container-xs mt-2'
                : 'style-buttons-active-container-xs';
        },
        hasAnySelectedRoomTypes() {
            return this.selectedRoomTypes.length > 0;
        },
    },
    watch: {
        hasAnySelectedRoomTypes(newValue) {
            this.emptyRoomTypeAlertFlag = false;
            if (!newValue) {
                this.$store.commit('EMPTY_SELECTED_STYLES');
            }
        },
    },
    methods: {
        openStylesModal() {
            if (this.hasAnySelectedRoomTypes) {
                this.$emit('styleCategory-modal');
            } else {
                this.emptyRoomTypeAlertFlag = true;
            }
        },
    },
    data() {
        return {
            emptyRoomTypeAlertFlag: false,
        };
    },
};
</script>

<style lang="scss" scoped>
.style-buttons-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 50px;
    padding: 0 16px;
    border-radius: 16px;
}
.style-buttons {
    &-active-container-xs {
        @extend .style-buttons-container;
        background-color: rgba($color: $Accent-Light-Color, $alpha: 0.15);
        color: $Accent-Color;
    }
    &-inactive-container-xs {
        @extend .style-buttons-container;

        color: $Primary-Text-Color;
        border: 2px solid $Gray-Color;
    }
    &-advance-mode-btn-xs {
        border: none;
        background-color: $Primary-Text-Color;
        width: 100%;
        border-radius: 8px;
        height: 32px;
        color: $White-Color;
        font-weight: bold;
        font-size: 14px;
        display: inline-block;
    }
}
</style>
